import { Link, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import './LayoutWithSidebar.css';
import { useApp } from "../Contex";
import {availableLocations, fetchPermissions} from "../api/api";
import {NavLink, useNavigate} from "react-router";
import LackingPermissionPage from "./LackingPermissionPage";

export default function LayoutWithSidebar() {
    const navigate = useNavigate()
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const { setSid, getSid, clear, refresh, permissions, userName} = useApp();
    const [locations, setLocations] = useState([]);
    const [permList, setPermList] = useState({});

    useEffect(() => {
        availableLocations().then(res => {
            if (res.ok) setLocations(res.data);
        });
        fetchPermissions().then((res)=>{
            if (res.ok) {
                setPermList(res.permissions)
            }
        })
    }, [refresh]);

    const toggleSidebar = () => setIsSidebarOpen(prev => !prev);
    const closeSidebar = () => setIsSidebarOpen(false);

    const navLinks = [
        {to: "/hours", label: "Öppettider"},
        { to: "/menu", label: "Menyer" },
        {to: "/order", label: "Beställningar"},
        {to: "/cache", label: "Cache"},
        {to:"/config", label: "Konfiguration"},
        {to: "/zones", label: "Bord & Zoner"},
        {to: "/vouchers", label: "Rabattkoder"},
        {to: "/users", label: "Användare"},
        {to: "/appearance", label: "Utseende"}
        //{to: "/demo", label: "Demo",}
    ];

    return (
        <div className="d-flex vh-100">
            {/* Sidebar */}
            <div
                className={`sidebar mh-100 bg-light border-end d-flex flex-column justify-content-between p-3 ${isSidebarOpen ? 'open' : ''}`}
            >
                {/* Top: Nav and close button */}
                <div>
                    {/* Close button only on mobile */}
                    <div className="fs-4 d-block d-md-none" onClick={closeSidebar}>
                        <i className="bi bi-x-lg"></i>
                    </div>

                    <h3 className="mb-4 mt-2 fw-bold">QR ADMIN</h3>
                    <ul className="nav flex-column">
                        <li className="nav-item" key={"/"}>
                            <NavLink
                                to={"/"}
                                className={({isActive}) => `nav-link ${isActive ? 'card' : ''}`}
                                onClick={closeSidebar}
                            >
                                Dashboard
                            </NavLink>
                        </li>
                        {navLinks.map(({to, label}) => {
                                if (!permList[to.split("/")[1]]) return null
                                return <li className="nav-item" key={to}>
                                    <NavLink
                                        to={to}
                                        className={({isActive}) => `nav-link ${isActive ? 'card' : ''}`}
                                        onClick={closeSidebar}
                                    >
                                        {label}
                                    </NavLink>
                                </li>
                            }
                        )}
                    </ul>
                </div>

                {/* Bottom: Select + Logout */}
                <div>
                    <div className="form-group">
                        <label>Aktiv enhet</label>
                        <select
                            className="form-select p-2"
                            value={getSid ?? 0}
                            onChange={(e) => setSid(e.target.value)}
                        >
                        {locations?.map((place) => (
                                <option value={place.sid} key={place.sid}>{place.name}</option>
                            ))}
                        </select>
                    </div>
                    {userName && <Link className="p-2 btn bg-transparent my-1" to={"/account"} onClick={closeSidebar}>
                        <span>{userName} <i className="bi bi-person-circle"/> </span>
                    </Link>
                    }
                    <button
                        className="btn btn-outline-dark d-flex align-items-center gap-2 w-100 p-2"
                        onClick={clear}
                    >
                        <i className="bi bi-box-arrow-left"></i>
                        <span>Logga ut</span>
                    </button>
                </div>
            </div>


            {/* Main content */}
            <div className="flex-grow-1 d-flex flex-column mx-3" style={{overflow: 'hidden'}}>
                {/* Always-visible header with Menu button */}
                <div className="py-2" style={{flex: '0 0 auto'}}>
                    <button
                        onClick={toggleSidebar}
                        className="btn btn-link p-0 d-md-none"
                        style={{fontSize: '2rem', color: 'black'}}
                    >
                        <i className="bi bi-list"></i>
                    </button>
                </div>

                {/* Scrollable content area */}
                <div className="flex-grow-1 overflow-auto">
                    {(permissions?.write || permissions?.read )? <Outlet/> : <LackingPermissionPage/>}
                </div>
            </div>

        </div>
    );
}
